var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"overview"},[_c('h1',[_vm._v("Hello, "+_vm._s(_vm.getUserName()))]),_c('p',{staticClass:"lead"},[_vm._v("Welcome back to your account.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }